import {useMutation} from '@tanstack/react-query';
import {queryClient, apiClient} from '@common/http/query-client';
import {useNavigate} from 'react-router-dom';
import { useParams} from 'react-router-dom';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
export function useDuplicatePost() {
  const navigate = useNavigate();
  const { site_id } = useParams();
  // ✅ Correctly get the mutation function
  const mutation = useMutation({
    mutationFn: async (postId: number) => {
      
      const response = await apiClient.post(`blogs/post/${postId}/duplicate`);
      return response.data;
    },
    onSuccess: (data) => {
    	queryClient.invalidateQueries({ queryKey: ['blogs'] });
      
	    toast(message('Post duplicated'));
      	
    },
    onError: (error) => {
    	toast(message('Error duplicating post'));
    }
  });
  
  return mutation.mutate;
}
